import { PreviewDeliveryInGroup } from "../../../types/schedule/preview-delivery-in-group";
import { PreviewDeliveryInGroupDto } from "../../../types/schedule/preview-delivery-in-group-dto";
import { convertActionDtoToAction } from "../action/action-converter";
import { convertLoadDtoToLoad } from "../load/load-converter";
import { convertLocationDtoToLocation } from "../location/location-converter";
import { convertCompanyDtoToCompany } from "../user/company-convertor";
import { convertWorkPlaceDtoToWorkPlace } from "../work-place/work-place-converter";

export const convertPreviewDeliveryInGroupDtoToDeliveryInGroup = (
  deliveryInGroupDto: PreviewDeliveryInGroupDto
): PreviewDeliveryInGroup => {
  return {
    id: deliveryInGroupDto.id,
    status: deliveryInGroupDto.status,
    dateToWork: deliveryInGroupDto.dateToWork,
    inProgressLocation: convertLocationDtoToLocation(
      deliveryInGroupDto.inProgressLocation
    ),
    inProgressWorkPlace: convertWorkPlaceDtoToWorkPlace(
      deliveryInGroupDto.inProgressWorkPlace
    ),
    inProgressAction: convertActionDtoToAction(
      deliveryInGroupDto.inProgressAction
    ),
    pairLocation: convertLocationDtoToLocation(deliveryInGroupDto.pairLocation),
    pairWorkPlace: convertWorkPlaceDtoToWorkPlace(
      deliveryInGroupDto.pairWorkPlace
    ),
    pairAction: convertActionDtoToAction(deliveryInGroupDto.pairAction),
    invoiceNumber: deliveryInGroupDto.invoiceNumber,
    load: convertLoadDtoToLoad(deliveryInGroupDto.load),
    comment: deliveryInGroupDto.comment,
    client: convertCompanyDtoToCompany(deliveryInGroupDto.client),
    agency: convertCompanyDtoToCompany(deliveryInGroupDto.agency),
  };
};
